import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipComponent } from './tooltip.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
  declarations: [TooltipComponent],
  imports: [
    CommonModule,
    NzIconModule,
    NzToolTipModule
  ],
  exports: [TooltipComponent]
})
export class TooltipModule { }
